export default __webpack_public_path__ + "static/media/allergy.a08aa50c.png";